import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取在职状态
import { sysInfoFn as _sysInfoFn } from 'api/org/per';
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Array],
      default: ''
    }
  },
  data: function data() {
    return {
      stateArr: [] // 可选项
    };
  },
  created: function created() {
    this.sysInfoFn();
  },
  methods: {
    handlerChange: function handlerChange(v) {
      // console.log(v)
      this.$emit('input', v);
    },
    // 获取在职状态
    sysInfoFn: function sysInfoFn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              _this.stateArr = res.data.state;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};